import React, { FC, useCallback, useMemo } from "react";
import { FormField } from "evergreen-ui";
import ReactDatePicker from "react-datepicker";

import { utcToEastern, easternToUtc } from "./EasternTime";

import "react-datepicker/dist/react-datepicker.css";
import "./tables/styles/TableView.css";
import "./styles/DateTimeInputField.css";

interface DateTimeInputFieldProps {
    label: string;
    value: Date | string | null;
    required?: boolean;
    isInvalid?: boolean;
    maxWidth?: string;
    /** When false, renders a date-only picker without time selection. Defaults to true. */
    showTime?: boolean;
    onChange: (date: Date | null) => void;
}

export const DateTimeInputField: FC<DateTimeInputFieldProps> = ({
    label,
    value,
    required,
    isInvalid,
    maxWidth,
    showTime = true,
    onChange,
}) => {
    const selected = useMemo((): Date | null => {
        if (!value) return null;
        try {
            const utc = value instanceof Date ? value : new Date(value);
            return utcToEastern(utc);
        } catch (_e) {
            return null;
        }
    }, [value]);

    const handleChange = useCallback((date: Date | null) => {
        onChange(date ? easternToUtc(date) : null);
    }, [onChange]);

    return (
        <FormField label={`${label} (ET)`} isRequired={required} marginBottom={24}>
            <div style={{ maxWidth: maxWidth ?? "300px" }}>
                <ReactDatePicker
                    className={`jc-datetime-input${isInvalid ? " jc-datetime-input--invalid" : ""}`}
                    calendarClassName={"jc-date-picker-popover-calendar"}
                    popperClassName={"jc-date-picker-popover"}
                    selected={selected}
                    dateFormat={showTime ? "MM/dd/yyyy, h:mm aa" : "MM/dd/yyyy"}
                    showTimeSelect={showTime}
                    timeFormat={"h:mm aa"}
                    timeIntervals={15}
                    placeholderText={"Select a date"}
                    onChange={handleChange}
                />
            </div>
        </FormField>
    );
};
